//
// const selectElement = document.querySelector("#sort_by");
// selectElement.addEventListener("change", function(event) {
//     console.log("変更されました", event.target.value);
// });

// const modalOpen = document.getElementsByClassName("swiper-container");
// for (let i = 0; i < modalOpen.length; i++) {
//     modalOpen[i].classList.add("modal-open");
// }

// const swiper = new Swiper(".swiper-container", {
//     slidesPerView: 1,
//     // Optional parameters
//     direction: "horizontal",
//     loop: true,
//     // If we need pagination
//     pagination: {
//         el: ".swiper-pagination"
//     },
//     // Navigation arrows
//     navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev"
//     },
//     // And if we need scrollbar
//     scrollbar: {
//         el: ".swiper-scrollbar"
//     }
// });

window.onload = function() {
    ///////////////////////////////////////
    //トップ
    const swiper = new Swiper(".kusaba_slider__container", {
      	autoplay: {
          delay: 5000,
          disableOnInteraction: false
      	},
      	speed: 900,
        slidesPerView: 1,
        // Optional parameters
        direction: "horizontal",
        loop: true,
        // If we need pagination
        pagination: {
            el: ".swiper-pagination"
        },
        // Navigation arrows
        navigation: {
            nextEl: ".js--sw-next",
            prevEl: ".js--sw-prev"
        },
        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar"
        }
    });
    ///////////////////////////////////////

    //商品横
    const sliderThumbnail_row2 = new Swiper(".kusaba_product-slider-thumbnail__container2", {
        slidesPerView: 5,
        spaceBetween: 8,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            // 750px以上の場合
            750: {
                slidesPerView: 15
            }
        }
    });

    const slider_row2 = new Swiper(".slider2", {
        loop: true,
        navigation: {
            nextEl: ".js--sw-next2",
            prevEl: ".js--sw-prev2"
        },
        thumbs: {
            swiper: sliderThumbnail_row2
        }
    });

    ///////////////////////////////////////
    //商品横
    const sliderThumbnail_row = new Swiper(".kusaba_product-slider-thumbnail__container", {
        slidesPerView: 5,
        spaceBetween: 8,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            // 750px以上の場合
            750: {
                slidesPerView: 15
            }
        }
    });

    const slider_row = new Swiper(".slider", {
        loop: true,
        navigation: {
            nextEl: ".js--sw-next",
            prevEl: ".js--sw-prev"
        },
        thumbs: {
            swiper: sliderThumbnail_row
        }
    });
    ///////////////////////////////////////
    //商品縦
    const sliderThumbnail_col = new Swiper(".kusaba_product-slider-thumbnail__container--col", {
        slidesPerView: 5,
        spaceBetween: 8,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            // 750px以上の場合
            750: {
                slidesPerView: 8
            }
        }
    });

    const slider_col = new Swiper(".kusaba_product-slider__container--col", {
        loop: true,
        navigation: {
            nextEl: ".js--sw-next",
            prevEl: ".js--sw-prev"
        },
        thumbs: {
            swiper: sliderThumbnail_col
        }
    });

    // const sliderThumbnail_col = new Swiper(".slider-thumbnail", {
    //     slidesPerView: 5,
    //     spaceBetween: 8,
    //     freeMode: true,
    //     watchSlidesVisibility: true,
    //     watchSlidesProgress: true,
    //     breakpoints: {
    //         // 750px以上の場合
    //         750: {
    //             slidesPerView: 8
    //         }
    //     }
    // });

    // const slider_col = new Swiper(".kusaba_product-slider__container--col", {
    //     loop: true,
    //     navigation: {
    //         nextEl: ".swiper-button-next",
    //         prevEl: ".swiper-button-prev"
    //     },
    //     thumbs: {
    //         swiper: sliderThumbnail_col
    //     }
    // });
};
